/* eslint-disable @stylistic/brace-style */

import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const VIDEO_ANALYTIC_TYPE_OPTIONS = optionsProxy.create([
  { value: 'crowd', get label() { return i18n.t('lunaApi:константы.video analytics.type.crowd'); } },
  { value: 'fight', get label() { return i18n.t('lunaApi:константы.video analytics.type.fight'); } },
  { value: 'weapon', get label() { return i18n.t('lunaApi:константы.video analytics.type.weapon'); } },
  { value: 'fire', get label() { return i18n.t('lunaApi:константы.video analytics.type.fire'); } },
  { value: 'facecover', get label() { return i18n.t('lunaApi:константы.video analytics.type.facecover'); } },
  { value: 'bag', get label() { return i18n.t('lunaApi:константы.video analytics.type.bag'); } },
  { value: 'lying', get label() { return i18n.t('lunaApi:константы.video analytics.type.lying'); } },
  { value: 'handsup', get label() { return i18n.t('lunaApi:константы.video analytics.type.handsup'); } },
  { value: 'fall', get label() { return i18n.t('lunaApi:константы.video analytics.type.fall'); } },
]);

export const FIRE_CLASS_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('lunaApi:константы.fire.0'); } },
  { value: 1, get label() { return i18n.t('lunaApi:константы.fire.1'); } },
  { value: 2, get label() { return i18n.t('lunaApi:константы.fire.2'); } },
]);

export const IMAGE_FORMAT_OPTIONS = optionsProxy.create([
  { value: 'JPEG', get label() { return i18n.t('lunaApi:константы.video analytics.image format.JPEG'); } },
  { value: 'PNG', get label() { return i18n.t('lunaApi:константы.video analytics.image format.PNG'); } },
]);

export const SENDING_TYPE_OPTIONS = optionsProxy.create([
  { value: 'second', get label() { return i18n.t('lunaApi:константы.video analytics.sending type.second'); } },
  { value: 'frame', get label() { return i18n.t('lunaApi:константы.video analytics.sending type.frame'); } },
]);

export const EVENT_POLICY_TRIGGER_OPTIONS = optionsProxy.create([
  { value: 'start', get label() { return i18n.t('lunaApi:константы.video analytics.event_policy.trigger.start'); } },
  { value: 'end', get label() { return i18n.t('lunaApi:константы.video analytics.event_policy.trigger.end'); } },
  { value: 'period', get label() { return i18n.t('lunaApi:константы.video analytics.event_policy.trigger.period'); } },
]);

export const LIVENESS_OPTIONS_STRICT = optionsProxy.create([
  { value: 0, get label() { return i18n.t('lunaApi:константы.liveness.0'); } },
  { value: 1, get label() { return i18n.t('lunaApi:константы.liveness.1'); } },
  { value: 2, get label() { return i18n.t('lunaApi:константы.liveness.2'); } },
]);

export const LIVENESS_OPTIONS = optionsProxy.create([
  ...LIVENESS_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
]);

export const EVENT_ENUMS = {
  BODY_BASIC_ATTRIBUTES: {
    APPARENT_GENDER: optionsProxy.create([
      { value: 0, get label() { return i18n.t('lunaApi:константы.event.body_basic_attributes.apparent_gender.0'); } },
      { value: 1, get label() { return i18n.t('lunaApi:константы.event.body_basic_attributes.apparent_gender.1'); } },
      { value: 2, get label() { return i18n.t('lunaApi:константы.event.body_basic_attributes.apparent_gender.2'); } },
      { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
    ]),
  },
  UPPER_BODY: {
    HEADWEAR: optionsProxy.create([
      { value: 0, get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.0'); } },
      { value: 1, get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.1'); } },
      { value: 2, get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.2'); } },
      { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
    ]),
    HEADWEAR_COLORS: optionsProxy.create([
      { value: 'undefined', get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.colors.undefined'); } },
      { value: 'black', get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.colors.black'); } },
      { value: 'white', get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.colors.white'); } },
      { value: 'other', get label() { return i18n.t('lunaApi:константы.event.upper_body.headwear.colors.other'); } },
      { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
    ]),
    SLEEVE: optionsProxy.create([
      { value: 'short', get label() { return i18n.t('lunaApi:константы.event.upper_body.sleeve.short'); } },
      { value: 'long', get label() { return i18n.t('lunaApi:константы.event.upper_body.sleeve.long'); } },
      { value: 'undefined', get label() { return i18n.t('lunaApi:константы.event.upper_body.sleeve.undefined'); } },
      { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
    ]),
    UPPER_CLOSING_COLOR: optionsProxy.create([
      { value: 'black', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.black'); } },
      { value: 'blue', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.blue'); } },
      { value: 'green', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.green'); } },
      { value: 'gray', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.gray'); } },
      { value: 'orange', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.orange'); } },
      { value: 'purple', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.purple'); } },
      { value: 'red', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.red'); } },
      { value: 'white', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.white'); } },
      { value: 'yellow', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.yellow'); } },
      { value: 'pink', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.pink'); } },
      { value: 'brown', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.brown'); } },
      { value: 'beige', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.beige'); } },
      { value: 'khaki', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.khaki'); } },
      { value: 'multicolored', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.multicolored'); } },
      { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
      { value: 'undefined', get label() { return i18n.t('lunaApi:константы.event.upper_body.upper_closing_color.undefined'); } },
    ]),
  },
  LOWER_BODY: {
    LOWER_GARMENT: {
      TYPE: optionsProxy.create([
        { value: 'undefined', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.type.undefined'); } },
        { value: 'trousers', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.type.trousers'); } },
        { value: 'shorts', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.type.shorts'); } },
        { value: 'skirt', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.type.skirt'); } },
        { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
      ]),
      COLORS: optionsProxy.create([
        { value: 'black', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.black'); } },
        { value: 'blue', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.blue'); } },
        { value: 'green', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.green'); } },
        { value: 'gray', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.gray'); } },
        { value: 'orange', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.orange'); } },
        { value: 'purple', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.purple'); } },
        { value: 'red', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.red'); } },
        { value: 'white', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.white'); } },
        { value: 'yellow', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.yellow'); } },
        { value: 'pink', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.pink'); } },
        { value: 'brown', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.brown'); } },
        { value: 'beige', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.beige'); } },
        { value: 'khaki', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.khaki'); } },
        { value: 'multicolored', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.multicolored'); } },
        { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
        { value: 'undefined', get label() { return i18n.t('lunaApi:константы.event.lower_body.lower_garment.colors.undefined'); } },
      ]),
    },
    SHOES: {
      APPARENT_COLOR: optionsProxy.create([
        { value: 'undefined', get label() { return i18n.t('lunaApi:константы.event.lower_body.shoes.apparent_color.undefined'); } },
        { value: 'black', get label() { return i18n.t('lunaApi:константы.event.lower_body.shoes.apparent_color.black'); } },
        { value: 'white', get label() { return i18n.t('lunaApi:константы.event.lower_body.shoes.apparent_color.white'); } },
        { value: 'other', get label() { return i18n.t('lunaApi:константы.event.lower_body.shoes.apparent_color.other'); } },
        { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
      ]),
    },
  },
  ACCESSORIES: {
    BACKPACK: optionsProxy.create([
      { value: 0, get label() { return i18n.t('lunaApi:константы.event.accessories.backpack.0'); } },
      { value: 1, get label() { return i18n.t('lunaApi:константы.event.accessories.backpack.1'); } },
      { value: 2, get label() { return i18n.t('lunaApi:константы.event.accessories.backpack.2'); } },
      { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
    ]),
  },
};

export const TASKS = {
  TASKS_TYPE: optionsProxy.create([
    { value: 0, get label() { return 'unknown'; } },
    { value: 1, get label() { return 'linker'; } },
    { value: 2, get label() { return 'clusterization'; } },
    { value: 3, get label() { return 'report'; } },
    { value: 4, get label() { return 'garbage collect'; } },
    { value: 5, get label() { return 'additional extract'; } },
    { value: 6, get label() { return 'cross match'; } },
    { value: 7, get label() { return 'roc-curve calculation'; } },
    { value: 8, get label() { return 'export objects'; } },
    { value: 9, get label() { return 'estimate data'; } },
  ]),
  ESTIMATOR: {
    SOURCE: {
      SOURCE_TYPE: optionsProxy.create([
        { value: 'zip', get label() { return i18n.t('lunaApi:estimator task.source.source_type.zip'); } },
        { value: 'samba', get label() { return i18n.t('lunaApi:estimator task.source.source_type.samba'); } },
        { value: 'ftp', get label() { return i18n.t('lunaApi:estimator task.source.source_type.ftp'); } },
        { value: 'network_disk', get label() { return i18n.t('lunaApi:estimator task.source.source_type.network_disk'); } },
        { value: 's3', get label() { return i18n.t('lunaApi:estimator task.source.source_type.s3'); } },
      ]),
      IMAGE_TYPE: optionsProxy.create([
        { value: '0', get label() { return i18n.t('lunaApi:estimator task.source.image_type.0'); } },
        { value: '1', get label() { return i18n.t('lunaApi:estimator task.source.image_type.1'); } },
        { value: '2', get label() { return i18n.t('lunaApi:estimator task.source.image_type.2'); } },
      ]),
      SIGNATURE_VERSION: optionsProxy.create([
        { value: 's3v2', get label() { return i18n.t('lunaApi:estimator task.source.signature_version.s3v2'); } },
        { value: 's3v4', get label() { return i18n.t('lunaApi:estimator task.source.signature_version.s3v4'); } },
      ]),
    },
  },
};

// eslint-disable-next-line @stylistic/max-statements-per-line
const creationTokenPermission = { value: 'creation', get label() { return i18n.t('lunaApi.tokens.permissions.creation'); } };
// eslint-disable-next-line @stylistic/max-statements-per-line
const viewTokenPermission = { value: 'view', get label() { return i18n.t('lunaApi.tokens.permissions.view'); } };
// eslint-disable-next-line @stylistic/max-statements-per-line
const deletionTokenPermission = { value: 'deletion', get label() { return i18n.t('lunaApi.tokens.permissions.deletion'); } };
// eslint-disable-next-line @stylistic/max-statements-per-line
const modificationTokenPermission = { value: 'modification', get label() { return i18n.t('lunaApi.tokens.permissions.modification'); } };
// eslint-disable-next-line @stylistic/max-statements-per-line
const matchingTokenPermission = { value: 'matching', get label() { return i18n.t('lunaApi.tokens.permissions.matching'); } };

export const Token = {
  Permissions: {
    creation: creationTokenPermission,
    view: viewTokenPermission,
    modification: modificationTokenPermission,
    deletion: deletionTokenPermission,
    matching: matchingTokenPermission,
    crd: optionsProxy.create([
      creationTokenPermission,
      viewTokenPermission,
      deletionTokenPermission,
    ]),
    crm: optionsProxy.create([
      creationTokenPermission,
      viewTokenPermission,
      matchingTokenPermission,
    ]),
    crud: optionsProxy.create([
      creationTokenPermission,
      viewTokenPermission,
      modificationTokenPermission,
      deletionTokenPermission,
    ]),
    crudm: optionsProxy.create([
      creationTokenPermission,
      viewTokenPermission,
      modificationTokenPermission,
      deletionTokenPermission,
      matchingTokenPermission,
    ]),
    resources: optionsProxy.create([
      { value: 'iso', get label() { return i18n.t('lunaApi.tokens.permissions.iso'); } },
      { value: 'sdk', get label() { return i18n.t('lunaApi.tokens.permissions.sdk'); } },
      { value: 'liveness', get label() { return i18n.t('lunaApi.tokens.permissions.liveness'); } },
    ]),
  },
  VisibilityArea: optionsProxy.create([
    { value: 'account', get label() { return i18n.t('lunaApi.tokens.visibility_area.account'); } },
    { value: 'all', get label() { return i18n.t('lunaApi.tokens.visibility_area.all'); } },
  ]),
};
